import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
} from "@material-ui/core";

import ActivitiesTableField from "./fields/ActivitiesTableField";
import DeliverablesTableField from "./fields/DeliverablesTableField";
import { LongTextField, useFieldLabel } from "ra-friendsofbabba";
import MilestonesTableField from "./fields/MilestonesTableField";
import React from "react";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(4),
    "& table > tbody > tr:last-child td": {
      borderBottom: 0,
    },
    "& table tr td:first-child": {
      width: 50,
    },
  },
}));

const RowExpand = ({ record }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const fieldLabel = useFieldLabel({
    resource: "executive-project-work-packages",
  });
  return (
    <div className={classes.root}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{translate(fieldLabel("results"))}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <LongTextField source="results" record={record} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <ActivitiesTableField record={record} />
      <DeliverablesTableField record={record} />
      <MilestonesTableField record={record} />
    </div>
  );
};
export default RowExpand;
